<prox-main [parent]="this" [bodyTemplate]="bodyTemplate"></prox-main>

<ng-template #bodyTemplate>
  <h5 class="card-header">
    <div class="flex flex-row">
      <span>{{addressTypeName}}</span>
      <span *ngIf="!isBeingAdded"
        style="margin-left:10px; padding-top: 4px;  font-size:small; font-variant: small-caps; color: red;">{{statusMessage()}}</span>
    </div>
  </h5>
  <div *ngIf="isPageReady" class="flex flex-col grow w-1/2">

    <div class="card-body pr-3 mb-2">
      <prox-field label="Address Description">
        <input type="text" pInputText autocomplete="off" [pAutoFocus]="true"
          [(ngModel)]="accountAddress.description" [bzModel]="accountAddress" name="description" [disabled]="isReadOnly()">
      </prox-field>
    </div>
    <prox-address-frm [address]="accountAddress" [disabled]="isReadOnly()"></prox-address-frm>

    <!-- <div class="flex gap-3 pr-3" *ngIf="showInvoiceEmail()">
      <div class="w-full">
        <prox-field label="Invoice E-Mail" hint="Separate multiple addresses with semicolons">
          <input type="text" pInputText [(ngModel)]="accountAddress!.invoiceEmail" [bzModel]="accountAddress"
            [disabled]="isReadOnly()" name="invoiceEmail" />
        </prox-field>
      </div>
    </div>
    <div class="flex gap-3 pr-3" *ngIf="showInvoiceEmail()">
      <div class="w-full">
        <prox-field label="Portal Name" hint="Name of account website for invoice upload">
          <input type="text" pInputText [(ngModel)]="accountAddress!.portalName" [bzModel]="accountAddress"
            [disabled]="isReadOnly()" name="portalName" />
        </prox-field>
      </div>
    </div> -->

    <div class="flex mt-8 w-5/12">
      <div class="w-full">
        <p-checkbox [(ngModel)]="accountAddress.isBillingAddress" [binary]="true" [bzModel]="accountAddress"
          name="isBillingAddress" inputId="isBillingAddress"
          [disabled]="this.addressType==='B' || isReadOnly()"></p-checkbox>
        <label for="isBillingAddress" class="ml-2">Is Billing Address</label>
      </div>
      <div class="w-full">
        <p-checkbox [(ngModel)]="accountAddress.isShippingAddress" [binary]="true" [bzModel]="accountAddress"
          name="isShippingAddress" inputId="isShippingAddress"
          [disabled]="this.addressType==='S' || isReadOnly()"></p-checkbox>
        <label for="isShippingAddress" class="ml-2">Is Shipping Address</label>
      </div>
      <!-- <div class="w-1/3">
        <p-checkbox [(ngModel)]="accountAddress.isPersonalAddress" [binary]="true" [disabled]="isDisabled('P')" [bzModel]="accountAddress"
          name="isPersonalAddress" label="Is Personal Address"></p-checkbox>
      </div> -->
    </div>
    <!-- GoTo: reinstate validation once ShipStation offers a validation endpoint -->
    <!-- <div class="flex mt-6">
      <button (click)="onValidate()" pButton type="button" label="Validate Shipping Address" icon="fa-brands fa-ups"
        class="p-button-sm"  [disabled]="isReadOnly()"></button>
    </div> -->
  </div>

  <prox-save-cancel [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>

</ng-template>